import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Backdrop, StyledPortal } from "./style";

export const ANIM_DURATION = 1000;

let inTimeout = {};
let outTimeout = {};

const Portal = (props) => {
    const [state, setState] = useState(props.show ? "in" : "hidden");
    const [id] = useState(Math.round(Math.random() * 100000));
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);

    const outAnimCallback = () => {
        setState("out");
        if (outTimeout[id]) clearTimeout(outTimeout[id]);
        outTimeout[id] = setTimeout(() => {
            props.onHide && props.onHide();
            setState("hidden");
        }, ANIM_DURATION);
    };

    useEffect(() => {
        const callback = () => {
            const element = document.getElementById(`alert-${id}`);
            if (element) {
                setWidth(element.clientWidth);
                setHeight(element.clientHeight);
            } else {
                setTimeout(callback, 10);
            }
        };
        callback();
    }, [state, id]);

    useEffect(() => {
        if (state === "out") return;
        if (outTimeout[id]) clearTimeout(outTimeout[id]);
        if (inTimeout[id]) clearTimeout(inTimeout[id]);

        if (props.show) {
            setState("in");
            if (!props.duration) return;
            inTimeout[id] = setTimeout(outAnimCallback, props.duration);
        } else {
            outAnimCallback();
        }
    }, [props.show]);

    if (state === "hidden") return null;

    return (
        <>
            {props.backdrop && (
                <Backdrop
                    disabled={props.disabled}
                    state={state}
                    onClick={() => {
                        if (!props.closeOnBackdropClick) return;
                        outAnimCallback();
                    }}
                />
            )}
            <StyledPortal
                style={{ opacity: props.disabled ? 0 : 1 }}
                height={height}
                width={width}
                position={props.position}
                inAnimation={props.inAnimation}
                outAnimation={props.outAnimation}
                id={`alert-${id}`}
                state={state}
            >
                {props.children}
            </StyledPortal>
        </>
    );
};

Portal.defaultProps = {
    inAnimation: "bounceIn",
    outAnimation: "bounceOut",
    position: "center",
    backdrop: true,
    closeOnBackdropClick: true,
};

Portal.propTypes = {
    duration: PropTypes.any,
    show: PropTypes.bool,
    children: PropTypes.any,
    onHide: PropTypes.func,
    inAnimation: PropTypes.string,
    outAnimation: PropTypes.string,
    position: PropTypes.string,
    backdrop: PropTypes.bool,
    closeOnBackdropClick: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default Portal;
